// Reusable newsletter signup widget.
// Calls the subscribe-newsletter edge function.

import { useState } from 'react';
import { supabase } from '../../lib/supabase';

interface NewsletterSignupProps {
  /** Compact layout for footer embedding */
  compact?: boolean;
}

export function NewsletterSignup({ compact = false }: NewsletterSignupProps) {
  const [email,    setEmail]    = useState('');
  const [status,   setStatus]   = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message,  setMessage]  = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) return;

    setStatus('loading');
    try {
      const { data } = await supabase.functions.invoke('subscribe-newsletter', {
        body: { email: trimmed },
      });

      if (data?.ok) {
        if (data.data?.already) {
          setMessage('Você já está inscrito ✦');
        } else if (data.data?.reactivated) {
          setMessage('Inscrição reativada! Bem-vindo de volta ✦');
        } else {
          setMessage('Inscrito com sucesso! Em breve receberá nossas novidades ✦');
        }
        setStatus('success');
        setEmail('');
      } else {
        setMessage(data?.error ?? 'Erro ao inscrever. Tente novamente.');
        setStatus('error');
      }
    } catch {
      setMessage('Erro de conexão. Tente novamente.');
      setStatus('error');
    }
  }

  if (compact) {
    return (
      <div>
        {status === 'success' ? (
          <p style={{ color: '#4ade80', fontSize: 'var(--text-caption)', fontWeight: 600 }}>
            ✦ {message}
          </p>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '0.4rem' }}>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              style={{ flex: 1, fontSize: '13px', padding: '0.4rem 0.6rem', minWidth: 0 }}
            />
            <button
              type="submit"
              className="btn btn-primary btn-sm"
              disabled={status === 'loading'}
              style={{ flexShrink: 0 }}
            >
              {status === 'loading' ? '...' : 'OK'}
            </button>
          </form>
        )}
        {status === 'error' && (
          <p style={{ color: '#f87171', fontSize: 'var(--text-caption)', marginTop: '0.25rem' }}>{message}</p>
        )}
      </div>
    );
  }

  return (
    <div className="card" style={{
      border: '1px solid rgba(245,200,66,0.2)',
      background: 'linear-gradient(135deg, rgba(245,200,66,0.06) 0%, transparent 100%)',
      textAlign: 'center',
    }}>
      <p className="font-display" style={{ fontSize: '1.125rem', marginBottom: '0.4rem' }}>
        ✦ Receba novidades astrológicas
      </p>
      <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-label)', marginBottom: '1.25rem' }}>
        Previsões, curiosidades e conteúdo exclusivo no seu email. Sem spam.
      </p>

      {status === 'success' ? (
        <p style={{ color: '#4ade80', fontWeight: 600, fontSize: 'var(--text-label)' }}>✦ {message}</p>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '0.5rem', maxWidth: '400px', margin: '0 auto' }}>
          <input
            type="email"
            className="form-input"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="seu@email.com"
            required
            style={{ flex: 1, minWidth: 0 }}
          />
          <button
            type="submit"
            className="btn btn-primary"
            disabled={status === 'loading'}
            style={{ flexShrink: 0 }}
          >
            {status === 'loading' ? '...' : 'Inscrever ✦'}
          </button>
        </form>
      )}
      {status === 'error' && (
        <p style={{ color: '#f87171', fontSize: 'var(--text-caption)', marginTop: '0.5rem' }}>{message}</p>
      )}
    </div>
  );
}
